import p from 'x/config/platform-specific'

const XTextEditor = p.comp.getXTextEditor()

export default XTextEditor
